import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsAuth } from '@/entities/Admin';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import { routerPath } from '@/shared/config/router';

interface PublicRouteProps {
  children: ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const isAuth = useSelector(getIsAuth);
  const accessToken = LocalStorageService.getAccessToken();

  if (isAuth || accessToken) {
    return <Navigate to={routerPath.main} replace />;
  }

  return <>{children}</>;
};


